import { MCV4U } from "../../data/OSSD/Grade12/MCV4U";
import GradeCourseTemplate from "../../pageTemplate/GradeCourseTemplate";

export default function MCV4UPage() {
    return (
        <div>
            <GradeCourseTemplate data={MCV4U} />
        </div>
    )
}